import { type AnyRouter, RouterProvider } from "@tanstack/react-router";

import { useForgePathSegment, useForgeRouting } from "../lib/forgePath.js";

/**
 * The storefront's router, with the Forge's pages at the store's word for them
 * (`lib/forgePath.ts`). The router is created before the store's config is known, so the rewrite
 * reaches it here, through RouterProvider's options, before its first load.
 */
export function StorefrontRouter({ router }: { router: AnyRouter }) {
  const rewrite = useForgeRouting(router, useForgePathSegment());
  return <RouterProvider router={router} rewrite={rewrite} />;
}
